import { cn } from "@/lib/utils";
import { StarIcon } from "lucide-react";

/** Marks a player as staff in the playerlist. */
export default function TeamStar({ className }: { className?: string }) {
    return (
        <span
            title="Teammitglied"
            className={cn("inline-flex shrink-0 align-[-0.125em]", className)}
        >
            <StarIcon className="size-3.5 text-accent fill-accent" />
        </span>
    );
}
